import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ConfirmDialog from 'components/Dialog/Confirm';
import CompanyWorkingModal from './CompanyWorkingModal';
import {fetchCompanyList, tryUpdateCompany, tryAddCompany, tryDeleteCompany} from 'actions/CompanyActions.js';
import {getURL} from '../../routes';

class CompanyPanel extends Component {
  state = {
    mode: 'OFF',
    selectedID: 0
  }

  dismiss = () => {
    this.setState({mode: 'OFF'})
  }

  activeAdd = () => {
    this.setState({mode: 'ADD', selectedID: 0})
  }

  activeEdit = (id) => {
    return () => this.setState({mode: 'EDIT', selectedID: id})
  }

  componentDidMount() {
    this.props.dispatch(fetchCompanyList());
  }

  handleDelete = (id, name) => {
    return () => {
      ConfirmDialog(`確認是否删除${name}`)
        .then(
          () => {
            this.props.dispatch(tryDeleteCompany(id))
          },
          () => {}
        )
    }
  }

  handleAdd = (name, ownerName, contact, address) => {
    this.props.dispatch(tryAddCompany(name, ownerName, contact, address));
    this.dismiss();
  }

  handleEdit = (id) => {
    return (name, ownerName, contact, address) => {
      this.props.dispatch(tryUpdateCompany(id, name, ownerName, contact, address))
      this.dismiss();
    }
  } 

  buildCompanyRow = (companyList) => {
    return companyList.map((company) => {
      let id = company.get('id');
      let name = company.get('name');

      return (
        <tr key={id}>
          <th>
            {name}
          </th>
          <th>
            <button 
              className="btn btn-default"
              onClick={this.activeEdit(id)}>
              <span className="glyphicon glyphicon-pencil"/>
            </button>
            {" "}
            <button 
              className="btn btn-danger"
              onClick={this.handleDelete(id, name)}>
              <span className="glyphicon glyphicon-trash" />
            </button>
          </th>
        </tr>
      )
    })
  }

  render() {
    let {companyList, dispatch} = this.props;
    let {mode, selectedID} = this.state;
    
    return (
      <div className="company setting-panel">
        <div className="setting-header">
          <button 
            className="btn btn-default"
            onClick={()=>{dispatch(push(getURL('/ws-admin/setting')))}}>
            返回
          </button>
          <button
            className="btn btn-primary pull-right"
            onClick={this.activeAdd}>
            新增
          </button>
        </div>
        <div className="setting-content">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="name">
                  名稱
                </th>
                <th className="action">
                  動作
                </th>
              </tr>
            </thead>
            <tbody>
              {companyList.size > 0 && this.buildCompanyRow(companyList)}
            </tbody>
          </table>
        </div>
        {(mode === 'ADD' || mode === 'EDIT') && 
          <CompanyWorkingModal 
            action={(selectedID > 0? this.handleEdit(selectedID) : this.handleAdd)}
            dismiss={this.dismiss}
            mode={mode} 
            id={selectedID} 
            company={(selectedID > 0 ? companyList.get(companyList.findIndex((company) => company.get('id') === selectedID)) : "")}
            />}
      </div>
    )
  }
}

export default connect((state) => ({
  companyList: state.company
}))(CompanyPanel);


// WEBPACK FOOTER //
// ./src/components/Setting/CompanyPanel.js